import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { take } from 'lodash';
import OwnerCell from './cell';
import styles from './styles.css';


class TopLeaders extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { owners } = this.props;
    if (owners.length === 0) {
      return null;
    }
    return (
      <div className={styles.row}>
        {take(owners, 5).map(owner => <OwnerCell requestShowDeals={this.props.requestShowDeals} key={owner.user_id} owner={owner} />)}
      </div>
    );
  }
}

TopLeaders.propTypes = {
  owners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  requestShowDeals: PropTypes.func,
};

TopLeaders.defaultProps = {
  requestShowDeals: () => {},
};

export default TopLeaders;
